import ScoreByDayOfWeekBarChart from './ScoreByDayOfWeekBarChart';
export default ScoreByDayOfWeekBarChart;



// WEBPACK FOOTER //
// ./src/components/ScoreByDayOfWeekBarChart/index.js